// Picks which workspace to open when the URL has no valid one (bare root, or a
// workspace the user left). The "last opened" workspace is stored on the user
// doc (users/{uid}.lastWorkspaceUrlId) so it follows them across devices and
// survives cache clears — read during bootstrap, written when a workspace opens.

// Returns the workspace urlId to open automatically, or null when a picker should
// be shown (multiple workspaces and no valid remembered one).
export function resolveDefaultWorkspace(
    workspaceUrlIds: string[],
    lastWorkspaceUrlId: string | null | undefined,
): string | null {
    if (workspaceUrlIds.length <= 1) return workspaceUrlIds[0] ?? null
    return lastWorkspaceUrlId && workspaceUrlIds.includes(lastWorkspaceUrlId)
        ? lastWorkspaceUrlId
        : null
}
